import { useParams } from "react-router-dom";
import CompanyNavBar from "../Components/companyNavBar";
import CompanyVisual from "../Components/Visual/companyVisual";
import Footer from "../Components/footer";
import Results from "../Components/results";
import { useEffect, useState } from "react";
import config from "../Api/config";
import { DatabaseProduct } from "../Api/Database";
import useLazyLoaderWSearch from "../Api/lazyLoadingWSearch";
import ReactGA from "react-ga4";

function CompanyPage() {

    ReactGA.send({ hitType: "pageview", page: "/company/:company", title: "Company" });

    const { company } = useParams();
    const [brandData, setBrandData] = useState({});
    const [products, setProducts] = useState<DatabaseProduct[]>([]);

    const {lazyLoadingRef, elements, end, loading, filterElement} = useLazyLoaderWSearch<DatabaseProduct, HTMLDivElement>({elementFetcher: (offset: string, limit: string) => {
        if(company !== undefined) {
            return config.API.getProducts(company,"with_variants", "20", offset)
        }else{
            return config.API.getProducts("none","with_variants", "20", offset)
        }

    }, elementFilter: (product: DatabaseProduct, value: string) => {
        if( product.id !== undefined){
            return product.title.toLowerCase().includes(value.toLowerCase()) || product.id.toLowerCase().includes(value.toLowerCase());
        }
        return false;
    }})
    const [filteredProducts, setFilteredProducts] = useState<DatabaseProduct[]>(products);

    useEffect(() => {
        // get brand data for logo
        if(company != undefined ){
            config.API.getOwner(company).then((item) => {
                setBrandData(item);
            })
        }
    }, []);

    useEffect(() => {
        // get all products
        if(company != undefined ){
            config.API.getProducts(company,"parent_list").then((item) => {
                setProducts(item.results);
            })
        }
    }, []);

    useEffect(() => {
        if(products.length > 0) {
            setFilteredProducts(products)
        }
    }, [products])

    
    
    function filterValueHandler(value: string) {
        filterElement(value);
    }

    return (
        <div className="company"  ref={lazyLoadingRef}>
            <div className="explorerPublic">
                <CompanyNavBar data={brandData}  product={false}/>
                <CompanyVisual filterValue={filterValueHandler}/>
                <Results data={elements} company={company} end={end}/>
            </div>
            <Footer />
        </div>
    );
}

export default CompanyPage;
